<!-- Brand Logo -->
<div class="d-flex justify-content-center">
  <a [routerLink]="['/dashboard']" class="brand-link">
    <img src="assets/img/logo.png" alt="Admin Panel" class="img-fluid">
  </a>
</div>

<!-- Sidebar -->
<div class="sidebar" style="height: fit-content;">
  <!-- Sidebar user (optional) -->
  <div class="user-panel mt-3 pb-2 d-flex" style="justify-content: start; align-items: center">
    <img [src]="user?.photoURL || 'assets/img/default-profile.png'" alt="User Image" width="34" height="34" rounded="true" /> <!-- missing ? because of that the app throwing error -->
    <div class="info">
      <a [routerLink]="['/profile']" class="d-block">
        {{ user?.email }} <!-- missing ? because of that the app throwing error -->
      </a>
    </div>
  </div>

  <div class="form-inline">
    <app-sidebar-search></app-sidebar-search>
  </div>

  <!-- Sidebar Menu -->
  <nav class="mt-2" style="overflow-y: hidden">
    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
      <app-menu-item *ngFor="let item of menu" [menuItem]="item" />
    </ul>
  </nav>
</div>
